import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../Axios.js";

export default function ProjectList() {
  const [projects, setProjects] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null); // State to manage the selected image
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility

  // Fetch project data from API
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_BASE_URL}/api/v1/projects/all`);
        setProjects(response.data.projects);
      } catch (error) {
        console.error("Error fetching projects:", error);
        toast.error("Failed to fetch project data.");
      }
    };

    fetchProjects();
  }, []);

  // Function to open the modal with the selected image
  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-100 text-gray-800 overflow-hidden">
      <ToastContainer position="top-center" autoClose={3000} />

      {/* Banner Section */}

      {/* Main Content Section */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12">
        {/* Page Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-pink-600 to-red-500 text-center mb-16">
          Explore Incredible Student Projects
        </h1>

        {/* Loop through projects and render cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects?.map((project) => (
            <div
              key={project._id}
              className="flex flex-col bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow duration-300 border-4 border-teal-500"
            >
              {/* Project Image */}
              <div
                className="flex items-center justify-center mb-4 cursor-pointer"
                onClick={() =>
                  openModal(`/api/uploads/projects/${project.projectImage}`)
                }
              >
                {project.projectImage ? (
                  <img
                    src={`/api/uploads/projects/${project.projectImage}`}
                    alt={project.projectName || "Project Image"}
                    className="w-full h-40 object-cover rounded-lg shadow-md"
                  />
                ) : (
                  <div className="text-gray-500 italic">No Image Available</div>
                )}
              </div>

              {/* Project Information */}
              <div className="flex-1 space-y-4">
                <h3 className="text-xl font-semibold text-purple-700">
                  {project.projectName || "Untitled Project"}
                </h3>
                <p className="text-gray-600 text-lg">
                  <strong>Student Name:</strong> {project.studentName || "Unknown"}
                </p>
                <p className="text-gray-600">
                  {project.projectDescription || "No description provided."}
                </p>
                <p className="text-gray-800 font-medium">
                  <strong>Technologies Used:</strong>{" "}
                  {project.technologiesUsed?.join(", ") || "N/A"}
                </p>
                <p className="text-xs text-gray-500 italic">
                  <strong>Submitted on:</strong>{" "}
                  {project.submittedDate
                    ? new Date(project.submittedDate).toLocaleDateString()
                    : "N/A"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="relative bg-white p-6 rounded-lg max-w-5xl mx-auto max-h-screen overflow-hidden">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 font-bold"
            >
              X
            </button>
            <img
              src={selectedImage}
              alt="Large Project Image"
              className="w-full h-auto max-h-screen object-contain rounded-lg"
            />
          </div>
        </div>
      )}


    </div>
  )
}
